import { useRouter } from "../../../../../../../../lib/routerContext";
import { getPage } from "../helpers";
import { QueryPage } from "../types";

export const usePage = (): number => {
  const router = useRouter<QueryPage>();
  return getPage(router);
};
